
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4a4 4 0 118 0 4 4 0 01-8 0zm12.719 12a3.281 3.281 0 016.562 0 3.281 3.281 0 01-6.562 0zm-3.206 8.485a2.972 2.972 0 115.945.001 2.972 2.972 0 01-5.945-.001zM13.308 28a2.692 2.692 0 115.383 0 2.692 2.692 0 01-5.383 0zm-8.231-3.515a2.439 2.439 0 114.877.001 2.439 2.439 0 01-4.877-.001zM1.792 16a2.208 2.208 0 114.416 0 2.208 2.208 0 01-4.416 0zm3.723-8.485a2 2 0 114 0 2 2 0 11-4 0zm22.593 0a3.623 3.623 0 11-7.246 0 3.623 3.623 0 017.246 0z"}})])
          )
        }
      }
    